import { render, staticRenderFns } from "./NewslettersAdmin.vue?vue&type=template&id=7896e11d&scoped=true"
import script from "./NewslettersAdmin.vue?vue&type=script&lang=js"
export * from "./NewslettersAdmin.vue?vue&type=script&lang=js"
import style0 from "./NewslettersAdmin.vue?vue&type=style&index=0&id=7896e11d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7896e11d",
  null
  
)

export default component.exports